// removed by extract-text-webpack-plugin
module.exports = {"root":"_3dwTR","link":"_17mEy","title":"_36dri","descr":"_3QIFi","dateBlock":"_BScqx","dot":"_2Kjy6"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Banner/components/BannerContent/BannerContent.scss
// module id = 1120
// module chunks = 2